import * as _ from 'lodash';
import JsonApiReference from './jsonapi-reference';

export default class JsonApiRelationship {
  data: JsonApiReference | JsonApiReference[];

  constructor(init?: Partial<JsonApiRelationship>);
  constructor(init: JsonApiReference);
  constructor(init: JsonApiReference[]);
  constructor(init?: any) {
    if (init instanceof JsonApiReference) {
      this.data = init;
    } else if (init instanceof Array) {
      this.data = _.map(
        init,
        item => (item instanceof JsonApiReference ? item : new JsonApiReference(item))
      );
    } else if (init) {
      _.assign(this, init);
    }
  }
}



// WEBPACK FOOTER //
// ./common/models/jsonapi-relationship.ts